
if (!customElements.get('product-card-swatches')) {
  class ProductCardSwatches extends HTMLElement {
    constructor() {
      super();

      this.productCardEl = this.closest('.js-product-card');
      this.imageSwitcher = document.querySelector('image-switcher');
    }

    connectedCallback() {
      this.addEventListeners();
    }

    addEventListeners() {
      this.addEventListener('click', this.onSwatchClick);
    }

    onSwatchClick(event) {
      const swatch = event.target.closest('.js-swatch-color');
      if (!swatch) return;

      const variantUrl = swatch.dataset.variantUrl;
      const imageUrl = this.getImageUrl(swatch);

      this.changeProductUrl(variantUrl);
      this.changeVariantImage(imageUrl);
      this.changeLifestyleImage(swatch);
      this.changeCutoutImages(swatch);
      this.toggleActiveSwatch(swatch);
    }

    getImageUrl(swatch) {
      if (!this.imageSwitcher) return swatch.dataset.variantImage;

      return this.imageSwitcher.currentMode === 'alternative' ? (swatch.dataset.lifestyleImage || swatch.dataset.variantImage) : swatch.dataset.variantImage;
    }

    changeProductUrl(url) {
      if (!url) return;

      const linkElems = this.productCardEl.querySelectorAll('.js-product-link');
      linkElems.forEach(linkEl => {
        linkEl.href = url;
      });
    }

    changeVariantImage(imageUrl) {
      if (!imageUrl) return;

      const variantImageEl = this.productCardEl.querySelector('.js-variant-image');
      if (variantImageEl) {
        variantImageEl.setAttribute('src', imageUrl);
        variantImageEl.setAttribute('srcset', imageUrl);
      }
    }

    changeLifestyleImage(swatch) {
      if (!swatch) return;

      const lifestyleEl = this.productCardEl.querySelector('.js-lifestyle-image');
      const lifestyleUrl = swatch.dataset.lifestyleImage;

      if (!lifestyleEl || !lifestyleUrl) return;

      lifestyleEl.setAttribute('src', lifestyleUrl);
      lifestyleEl.setAttribute('srcset', lifestyleUrl);
    }

    changeCutoutImages(swatch) {
      if (!swatch || !this.productCardEl) return;

      const secondCutout = this.productCardEl.querySelector('.js-variant-image-2');

      if (!secondCutout) return;

      this.swapImage(this.productCardEl.querySelector('.js-variant-image'), swatch.getAttribute('data-cutout-image-1') || swatch.dataset.variantImage);
      this.swapImage(secondCutout, swatch.getAttribute('data-cutout-image-2'));
    }

    swapImage(imageEl, imageUrl) {
      if (!imageEl || !imageUrl) return;

      imageEl.setAttribute('src', imageUrl);
      imageEl.setAttribute('srcset', imageUrl);
    }

    toggleActiveSwatch(swatch) {
      if (!swatch) return;

      const swatchElems = this.productCardEl.querySelectorAll('.js-swatch-color');
      swatchElems.forEach(swatchEl => {
        swatchEl.classList.remove('swatch--selected');
      });
      swatch.classList.add('swatch--selected');
    }
  }

  customElements.define('product-card-swatches', ProductCardSwatches);
}
